import { PATHS } from '../const/paths.constants';
import { IAssignPayload, IBooking } from '../interfaces/booking.interface';
import { API as API_SERVICE } from './config-service.api';

export const getBooking = async (id: string): Promise<IBooking> => {
    const response = await API_SERVICE.get<IBooking>(`/bookings/${id}`);
    return response.data;
};

export const getBookings = async (queryParams: Record<string, unknown>) => {
    const res = await API_SERVICE.get('/bookings', { params: queryParams });
    return res;
};

export const getMiniBookings = async (queryParams: Record<string, unknown>) => {
    const res = await API_SERVICE.get('/mini-bookings', { params: queryParams });
    return res;
};

export const getBookingEvents = (id: string) => API_SERVICE.get(`/bookings/${id}/events`);

export const unassignDriver = (id: string, driverID: string) => API_SERVICE.post(`bookings/${id}/unassign-driver`, { driverID });

export const manualAssignDriver = (payload: IAssignPayload) => {
    const {
        bookingID,
        driverID,
        token,
        driverTag,
        orderID,
    } = payload;

    const Authorization = `Bearer ${token}`;
    const url = `${PATHS.BOOKINGS}/${bookingID}/manual-assign-driver/${driverID}`;

    return API_SERVICE.post(url, { driverTag, orderID }, { headers: { Authorization } });
};
